var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-3",attrs:{"color":"green","outlined":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save.btn')))])}
var staticRenderFns = []

export { render, staticRenderFns }